<template>
  <div style="width: 100%;">
    <div class="table_wrapper">
      <div class="table_wrapper_search mb16">
        <yxt-select
          v-model="selectType"
          :placeholder="$t('pc_biz_lbl_selecttip')"
          style="width: 200px;"
          @change="getSkillsList(true)"
        >
          <yxt-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </yxt-select>
        <yxt-input
          v-model="params.searchKey"
          class="keyword ml12"
          :placeholder="$t('pc_biz_gwnl_pleaseEnterLabelName', { prefixLabel: prefixLabel })"
          style="width: 280px;"
          searchable
          @keyup.enter.native="getSkillsList(true)"
          @search="getSkillsList(true)"
        />
      </div>
      <yxt-table
        ref="multipleTable"
        v-loading="loading"
        class="person-table"
        row-key="id"
        :data="tableData"
        :max-height="maxHeight"
        @select="handleSingleSeletct"
        @select-all="handleSelectAll"
      >
        <yxt-table-column
          type="selection"
          :show-overflow-tooltip="false"
          :selectable="selectEvent"
          class-name="table-selection-odd"
          width="55"
        />
        <yxt-table-column
          :label="$t('biz_ability_abilityName')"
          min-width="180"
        >
          <template slot-scope="{ row }">
            <div class="flex gwnl-flex-width">
              <yxt-popover
                placement="top"
                trigger="hover"
                show-scroll
                max-width="198"
                max-height="144"
                :open-filter="true"
                :content="row.name"
                class="ellipsis"
              >
                <div
                  slot="reference"
                  class="ellipsis"
                >
                  {{ row.name }}
                </div>
              </yxt-popover>
              <div
                v-if="row.cloudType"
                class="flex-1"
              >
                <yxt-tag
                  size="mini"
                  class="ml8"
                >
                  {{ $t('pc_biz_gwnl_global_cloud') }}
                </yxt-tag>
              </div>
            </div>
          </template>
        </yxt-table-column>
        <yxt-table-column
          :label="$t('biz_ability_abilityType')"
          min-width="100"
        >
          <template slot-scope="{ row }">
            {{ getAbilityType(row.general) }}
          </template>
        </yxt-table-column>
        <yxt-table-column
          :label="$t('biz_ability_abilityDesc')"
          min-width="320"
          show-overflow-tooltip
          prop="description"
        />
      </yxt-table>
      <gwnl-pager
        :pager="pager"
        @searchData="getSkillsList()"
      />
    </div>
  </div>
</template>

<script>
import echoMixin from '..//mixin/echo';
import GwnlPager from './pager';

export default {
  name: 'AbilitySelectorByType',
  mixins: [echoMixin],
  components: {GwnlPager},
  props: {
    getSkills: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      prefixLabel: this.$t('pc_biz_gwnl_ability'),
      loadingAll: false,
      refTable: 'multipleTable',
      currentPage: 1,
      total: 0,
      loading: true,
      params: {
        searchKey: '',
        deptId: '',
        limit: 10,
        offset: 0,
        scope: 0
      },
      pager: {
        pages: 0,
        pageSize: 20,
        total: 0,
        limit: 20,
        offset: 0
      },
      tableHeight: 490,
      maxHeight: window.innerHeight - 262,
      tableData: [],
      formatPostion: row => {
        if (row.positionName) {
          return row.positionName;
        }
        return row.positionSet
          .map(item => {
            return item.name;
          })
          .join(';');
      },
      typeOptions: [
        {
          label: this.$t('pc_biz_knglib_lbl_all'),
          value: -1
        },
        {
          label: this.$t('biz_gwnl_generalAblity'),
          value: 1
        },
        {
          label: this.$t('biz_gwnl_professionalAblity'),
          value: 0
        }
      ],
      selectType: -1
    };
  },
  mounted() {
    this.getSkillsList();
  },
  methods: {
    init() {
      this.getSkillsList();
    },
    getAbilityType(general) {
      let matched = this.typeOptions.find(type => type.value === general);
      return matched ? matched.label : '';
    },
    getSkillsList(current) {
      let data = {
        keyword: this.params.searchKey,
        general: this.selectType === -1 ? -2 : this.selectType,
        status: 1
      };
      let params = {
        limit: this.pager.pageSize,
        offset: current
          ? (current - 1) * this.pager.pageSize
          : this.pager.offset
      };
      this.loading = true;
      let skillsRes = typeof this.getSkills === 'function' ? this.getSkills(data, params) : this.$http.model.getSkillsList(data, params);
      skillsRes.then((res) => {
        if (res) {
          this.tableData = res.datas.map(data => {
            let { description, general, name, id, cloudType } = data;
            return {
              description,
              general,
              name,
              id,
              cloudType,
              _type: 0,
              type: 1 // 关联词条1，能力；2，任务
            };
          });
          this.pager.pages = res.paging.pages;
          this.pager.offset = res.paging.offset;
          this.pager.total = res.paging.count;
          this.update();
        }
      }).catch((e) => {
        console.error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.params.offset = (val - 1) * this.params.limit;
      this.getSkillsList();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.params.limit = val;
      this.getSkillsList();
    }
  }
};
</script>
